import React from 'react';

import style from './rate-recommendation.module.less';
import HelpArticleLink from '../../../components/help-article-link';
import { linkIDs } from '../../../services/link-service/links';
import { GlobalPostName } from '../../../enums/label-providers/globalpost/globalpost-service';

/**
 * @param {object} props
 * @param {string} props.shippingServiceName
 * @returns {React.JSX.Element|string}
 */
export const RecommendedShippingServiceName = ({ shippingServiceName = '' }) => {
  if (shippingServiceName.startsWith(GlobalPostName)) {
    const filtered = shippingServiceName.split(' ');
    filtered.shift();
    const suffix = filtered.join(' ');

    return (
      <span>
        <HelpArticleLink articleId={linkIDs.GlobalPostHelpArticle} className={style['help-link']}>
          {GlobalPostName}
        </HelpArticleLink>
        {` ${suffix}`}
      </span>
    );
  }

  return shippingServiceName;
};
